export const TENANT_TYPES_NAMES = {
  holding: 'Holding',
  subsidiary: 'Filial',
  independent: 'Independente',
}
